/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseCityMaster,
    PressReleaseCityMasterFromJSON,
    PressReleaseCityMasterFromJSONTyped,
    PressReleaseCityMasterToJSON,
} from './PressReleaseCityMaster';

/**
 * GET /press_release/prefecture/{pref_id}
 * @export
 * @interface GetPressReleaseCityMasterResponse
 */
export interface GetPressReleaseCityMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseCityMasterResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseCityMasterResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseCityMaster}
     * @memberof GetPressReleaseCityMasterResponse
     */
    data: PressReleaseCityMaster;
}

export function GetPressReleaseCityMasterResponseFromJSON(json: any): GetPressReleaseCityMasterResponse {
    return GetPressReleaseCityMasterResponseFromJSONTyped(json, false);
}

export function GetPressReleaseCityMasterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseCityMasterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseCityMasterFromJSON(json['data']),
    };
}

export function GetPressReleaseCityMasterResponseToJSON(value?: GetPressReleaseCityMasterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseCityMasterToJSON(value.data),
    };
}

